import { marketsCommonApi } from '@ultrade/react-sdk';
import { THEMES } from '../../constants/constants';
import { SettingIds, ThemeObj } from '../../interfaces';
import { getCurrentThemeFromLocalStorage } from '../../services/localStorage.service';

/** seting action types */
export const actionTypes = {
  SAVE_SETTINGS: 'SAVE_SETTINGS',
  SAVE_INITIAL_SETTINGS: 'SAVE_INITIAL_SETTINGS',
  SAVE_THEME: 'SAVE_THEME',
};

/*
 * Action creators for login
 */

export const saveSettings = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_SETTINGS,
    data: data,
  });

  const themeSettings = updateCurrentTheme(data);
  if (themeSettings) {
    dispatch({
      type: actionTypes.SAVE_THEME,
      data: themeSettings,
    });
    marketsCommonApi.util.updateQueryData('getSettings', undefined, (draft) => ({ ...draft, currentTheme: themeSettings.currentTheme }));
  }
};

export const updateCurrentTheme = (data) => {
  let currentTheme = getCurrentThemeFromLocalStorage();
  if (!THEMES.includes(currentTheme)) currentTheme = 'theme1';
  if (!JSON.parse(data[SettingIds.THEMES])[currentTheme].active) {
    const allThemes = Object.entries(JSON.parse(data[SettingIds.THEMES])) as [tname: string, obj: ThemeObj][];
    const activeTheme = allThemes.find(([, obj]) => obj.active);
    currentTheme = activeTheme[0];
  }

  if (currentTheme) {
    const themeSettings = {
      currentTheme,
      value: JSON.parse(data[SettingIds.THEMES])[currentTheme].value,
      logo: JSON.parse(data[SettingIds.LOGO])[currentTheme].value,
    };
    return themeSettings;
  }
};

export const saveInitialSettings = () => (dispatch) => {
  dispatch({
    type: actionTypes.SAVE_INITIAL_SETTINGS,
  });
};

export const saveTheme = (data) => (dispatch) => {
  const themeSettings = { currentTheme: data };
  dispatch({
    type: actionTypes.SAVE_THEME,
    data: themeSettings,
  });
};
